import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import LogoEmblem from "@/components/site/LogoEmblem";
import Marquee from "@/components/site/Marquee";
import Gallery from "@/components/site/Gallery";
import Heritage from "@/components/site/Heritage";
import About from "@/components/site/About";
import VideoShowcase from "@/components/site/VideoShowcase";
import InstagramSection from "@/components/site/InstagramSection";
import BlogTeaser from "@/components/site/BlogTeaser";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFAB from "@/components/site/WhatsAppFAB";

export default function Home() {
  return (
    <div className="min-h-screen bg-cream-100 text-ink" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <LogoEmblem />
        <Marquee />
        <VideoShowcase />
        <Gallery />
        <Heritage />
        <About />
        <InstagramSection />
        <BlogTeaser />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
